var I = /* @__PURE__ */ ((r) => (r.ALERT = "alert", r.INFORMATION = "information", r.CONFIRM = "confirm", r))(I || {});
export {
  I as NotificationType
};
//# sourceMappingURL=NotificationType.type.mjs.map
